export enum RunningUploadStatus {
  Pending = 'Pending',
  Uploading = 'Uploading',
  Failed = 'Failed',
  Done = 'Done',
}
